var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.confirm)?_c('v-btn',_vm._b({attrs:{"color":"warning"},on:{"click":function($event){return _vm.handleClick()}}},'v-btn',_vm.$attrs,false),[_vm._t("confirm",function(){return [_vm._v(" Confirmar? ")]})],2):_c('v-btn',_vm._b({on:{"click":function($event){return _vm.handleConfirm()}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }